import { IPersonnelDetailRequest, IPersonnelDetailState } from './PersonnelDetail.types';

export enum ActionTypes {
    PERSONNELDETAIL = 'PERSONNELDETAIL',
    PERSONNELDETAIL_REQUEST = 'PERSONNELDETAIL_REQUEST',
    PERSONNELDETAIL_SUCCEEDED = 'PERSONNELDETAIL_SUCCEEDED',
    PERSONNELDETAIL_FAILED = 'PERSONNELDETAIL_FAILED',
    PERSONNELDETAIL_SET_CLEARSTATE = 'PERSONNELDETAIL_SET_CLEARSTATE'
}

export type IPersonnelDetailActions =
    | IRequestPersonnelDetailAction
    | IReceivePersonnelDetailAction
    | ISetPersonnelDetailClearStateAction;

export interface IRequestPersonnelDetailAction {
    type: ActionTypes.PERSONNELDETAIL_REQUEST;
    data?: IPersonnelDetailRequest;
}

export interface IReceivePersonnelDetailAction {
    type: ActionTypes.PERSONNELDETAIL_SUCCEEDED | ActionTypes.PERSONNELDETAIL_FAILED;
    data: IPersonnelDetailState;
    message: string;
}

export interface ISetPersonnelDetailClearStateAction {
    type: ActionTypes.PERSONNELDETAIL_SET_CLEARSTATE;
    data: boolean;
}
